import ModelComponent from '../ModelComponent';

class PricingModel extends ModelComponent {
  constructor() {
    super();
    this.state = {};
    this.loading = false;
  }
}

export default PricingModel;